import HomePage from './pages/HomePage';
import FaqPage from './pages/FaqPage';
import TermsConditions from './pages/TermsConditions';
import Error404 from './pages/Error404';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Auth from './pages/AuthPage';
import Referral from './pages/Referral';
import Profile from './pages/Profile';
import AppErrorBoundary from './components/error-boundary';
import BannedStatusProvider from './components/BannedStatusWrapper';
import { Route, Routes } from 'react-router-dom';
import {
  FAQS_PAGE,
  HOME_PAGE,
  PRIVACY_POLICY_PAGE,
  PROFILE_PAGE,
  REFERRAL_PAGE,
  TERMS_AND_CONDITIONS_PAGE,
  VERIFY_PAGE,
  DOWNLOAD_PAGE,
} from './constants/route.const';
import { ggAnalytics } from './config/ga';
import { useEffect } from 'react';
import DownloadApp from 'pages/DownloadApp';

function App({ history }) {
  useEffect(() => {
    history.listen(history => {
      ggAnalytics.firePageView(
        `${history.pathname}${history.hash && history.hash}`
      );
    });
  }, []);

  return (
    <AppErrorBoundary>
      <BannedStatusProvider>
        <Routes>
          <Route path={HOME_PAGE} element={<HomePage />} />
          <Route path={VERIFY_PAGE} element={<Auth />} />
          <Route path={PROFILE_PAGE} element={<Profile />} />
          <Route path={PRIVACY_POLICY_PAGE} element={<PrivacyPolicy />} />
          <Route
            path={TERMS_AND_CONDITIONS_PAGE}
            element={<TermsConditions />}
          />
          <Route path={FAQS_PAGE} element={<FaqPage />} />
          <Route path={REFERRAL_PAGE} element={<Referral />} />
          <Route path={DOWNLOAD_PAGE} element={<DownloadApp />} />

          <Route path="*" element={<Error404 />} />
        </Routes>
      </BannedStatusProvider>
    </AppErrorBoundary>
  );
}

export default App;
